import {
    CloseIcon,
    ContentWrapper,
    ImageWrapper,
    PageWrapper,
    Wrapper
} from '../../PreviewPageModal/PreviewPageModal.style';
import { ModalProps } from 'components/Dialogs/types';
import { useAppSelector } from 'store/hooks';
import { selectPageById } from 'store/features/pages/selectors';
import { selectFileById } from 'store/features/files/selectors';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { FilesDictionary } from 'FileDictionary';
import { Document, Page } from '../../../../reactPDFConfigured';

const PreviewPageModal = ({ toggleModalOpen, actualPageId }: ModalProps) => {
    const [windowSize, setWindowSize] = useState([window.innerWidth, window.innerHeight]);

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const page = useAppSelector(selectPageById(actualPageId!));
    const file = useAppSelector(selectFileById(page.sourceFileId));

    if (file.fileName.toLowerCase().endsWith('.pdf')) {
        return (
            <Wrapper>
                <CloseIcon onClick={() => toggleModalOpen('save')} />

                <Document
                    file={FilesDictionary[page.sourceFileId]}
                    key={page.id}
                    loading={
                        <Box
                            width='100%'
                            height='200px'
                            display='flex'
                            justifyContent='center'
                            alignItems='center'
                            paddingBottom='46px'
                        >
                            <CircularProgress />
                        </Box>
                    }
                >
                    <PageWrapper>
                        <Page
                            pageNumber={page.pageNr}
                            width={windowSize[0] < 1365 ? windowSize[0] * 0.75 : 1024}
                            height={windowSize[0] < 1365 ? windowSize[0] * 0.537 : 1430}
                            loading={<h1>Ładowanie...</h1>}
                        />
                    </PageWrapper>
                </Document>
            </Wrapper>
        );
    }
    return (
        <Wrapper>
            <CloseIcon onClick={() => toggleModalOpen('save')} />
            <ContentWrapper>
                <ImageWrapper>
                    <img src={URL.createObjectURL(FilesDictionary[page.sourceFileId])} alt={file.fileName} />
                </ImageWrapper>
            </ContentWrapper>
        </Wrapper>
    );
};

export default PreviewPageModal;
